import React from "react";
import { Route, Routes } from "react-router-dom";
import ProgramDescription from "components/ProgramDescription/programDescription";
import ProgramsIndex from "components/ProgramPage/ProgramsIndex";
import "components/ProgramPage/programsPage.css";
import "./programDetails.css";

const ProgramDetails = () => (
  <main className="program-details-page">
    <Routes>
      <Route path="/" element={<ProgramsIndex />} />
      <Route path="/:programtype" element={<ProgramDescription />} />
    </Routes>
  </main>
);

export default ProgramDetails;
